const ActionType = {
  SET_LECTURES: 'SET_LECTURES',
  SET_REGIONS: 'SET_REGIONS',
  SET_SPECIALITIES: 'SET_SPECIALITIES',
  SET_THEMES: 'SET_THEMES',
  SET_COUNTRIES: 'SET_COUNTRIES',
  SET_CLINICAL_RECOMMENDATIONS: 'SET_CLINICAL_RECOMMENDATIONS',
}

export default ActionType
